<template>
    
    <div>

        <!-- Details Banner -->

        <div class="h-auto
                    bg-gray-100  
                    pt-24
                    pb-10
                    px-10
                    rounded-cs-xl 
                    rounded-t-none 
                    relative" 
        
        >

            <slider class="max-w-screen-xl m-auto" >

                <template v-slot:title >

                    <p class="text-lg text-gray-600 truncate" >Animals with outstanding info</p>

                </template>

                <template v-slot:utils >

                    <div class="w-96 grid grid-cols-4 gap-4 items-center" >

                        <p class="text-right" >Shelter:</p>

                        <c-select 
                        
                        class="col-span-3" 
                        
                        :height="40"
                        :color="true"
                        :showCount="true"
                        :list="shelters" 
                        
                        v-model="shelter" 
                        
                        />

                    </div>

                </template>

                <template v-slot:slider >

                    <div class="w-56
                                h-20 
                                bg-gray-200 
                                flex 
                                items-center 
                                justify-center 
                                rounded-lg" 
                    
                    :key="item" v-for="item in 30" 
                
                >
                
                    Item {{item}}
                
                </div>

                </template>

            </slider>

        </div>

        <!-- Details Body -->

        <div class="h-auto container m-auto p-10 py-24 grid grid-cols-5 gap-10" >

            <!-- Animal Info -->

            <div class="lg:col-span-3 col-span-5 relative section" >

                <div class="w-full h-12 flex items-center" >

                    <div class="text-xl font-medium w-10 h-10 flex items-center justify-center border-2 border-solid border-gray-400 rounded-lg" >1</div>

                    <h2 class="text-4xl font-medium ml-10" >Animal Info</h2>

                </div>

                <form class="grid grid-cols-4 gap-4 lg:ml-20 ml-0 mt-10 items-end" >

                    <c-input type="text" label="Animal Name" placeholder="Eg: Dora" class="col-span-2" :required="true" v-model="animalInfo.name" />

                    <c-select label="Age" />

                    <c-select />

                    <radio label="Animal Gender" class="col-span-2" :options="options.genderOptions" v-model="animalInfo.gender" />

                    <radio label="Type" class="col-span-2" :options="options.typeOptions" v-model="animalInfo.type" />

                    <radio label="Animal Type" class="col-span-4" :options="options.animalTypeOptions" v-model="animalInfo.animalType" />

                    <c-select label="Breed" class="col-span-4" :list="options.breedOptions" v-model="animalInfo.breed" />

                    <c-select label="Color" class="col-span-2" />

                    <c-select class="col-span-2" />

                </form>

            </div>

            <!-- User Info -->

            <div class="lg:col-span-3 col-span-5 relative section" >

                <div class="w-full h-14 flex items-center" >

                    <div class="text-xl font-medium w-10 h-10 flex items-center justify-center border-2 border-solid border-gray-400 rounded-lg" >2</div>

                    <h2 class="text-4xl font-medium ml-10" >Owner Info</h2>

                </div>

                <form class="grid grid-cols-4 gap-4 lg:ml-20 ml-0 mt-10 items-end" >

                    <c-input type="text" label="First Name" placeholder="Eg: John" class="col-span-2" :required="true" v-model="ownerInfo.firstName" />

                    <c-input type="text" label="Last Name" placeholder="Eg: Doe" class="col-span-2" :required="true" v-model="ownerInfo.lastName" />

                    <c-input type="text" label="Cell Phone" placeholder="Eg: 000 000 0000" class="col-span-2" :required="true" v-model="ownerInfo.cellPhone" />

                    <c-input type="text" label="Home Phone" placeholder="Eg: 000 000 0000" class="col-span-2" :required="true" v-model="ownerInfo.homePhone" />

                    <c-input type="text" label="Email" placeholder="Eg: john.doe@shelter.co" class="col-span-2" :required="true" v-model="ownerInfo.email" />

                    <c-textarea label="Appointment Notes" class="col-span-4" placeholder="Your Note..." />

                    <c-checkbox label="Checkbox" class="col-span-4" v-model="ownerInfo.checkbox" />

                    <geolocation class="col-span-4" />

                </form>

            </div>

            <div class="lg:col-span-2 lg:row-start-1 lg:col-start-4 col-span-5 col-start-1" >

                <div class="w-full h-14 flex items-center" >

                    <div class="text-xl font-medium w-10 h-10 flex items-center justify-center border-2 border-solid border-gray-400 rounded-lg" >3</div>

                    <h2 class="text-4xl font-medium ml-10" >Services</h2>

                </div>

            </div>

            <div class="lg:col-span-3 col-span-5" >

                <div class="w-full h-14 flex items-center" >

                    <div class="text-xl font-medium min-w-10 h-10 flex items-center justify-center border-2 border-solid border-gray-400 rounded-lg" >3</div>

                    <button class="btn w-full ml-10" >Submit Info</button>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

    import { ref, reactive } from 'vue'

    import radio from '../components/radio'
    import cInput from '../components/input'
    import slider from '../components/slider'
    import cSelect from '../components/select'
    import cCheckbox from '../components/checkbox'
    import cTextarea from '../components/textarea'
    import geolocation from '../components/geolocation'

    export default {
    
        name: 'Details',

        components: { cInput, cCheckbox, cTextarea, cSelect, slider, radio, geolocation },

        setup( props, context ) {

            const options = reactive({

                genderOptions: [

                    {
                        id: 1,
                        name: 'Male'
                    },
                    {
                        id: 2,
                        name: 'Female'
                    }
                ],

                typeOptions: [

                    {
                        id: 1,
                        name: 'Owned'
                    },
                    {
                        id: 2,
                        name: 'Shelter'
                    },
                    {
                        id: 3,
                        name: 'Foster'
                    }

                ],

                animalTypeOptions: [

                    {
                        id: 1,
                        name: 'Dog'
                    },
                    {
                        id: 2,
                        name: 'Cat'
                    },
                    {
                        id: 3,
                        name: 'Other'
                    }

                ],

                breedOptions: [

                    {
                        id: 1,
                        name: 'Beagle'
                    },
                    {
                        id: 2,
                        name: 'not Beagle'
                    }

                ]

            })

            const animalInfo = reactive({

                    name: '',
                    type: {},
                    gender: {},
                    animalType: {},
                    breed: [{
                        id: 1,
                        name: 'Beagle'
                    }]

            })

            const ownerInfo = reactive({

                firstName: '',
                lastName: '',
                cellPhone: '',
                homePhone: '',
                email: '',
                checkbox: true

            })

            // Mock 

            const shelter = ref([])
            const shelters = ref([

                {
                    id: 1,
                    name: 'Shelter 01'
                },
                {
                    id: 2,
                    name: 'Shelter 02'
                },
                {
                    id: 3,
                    name: 'Shelter 03'
                },
                {
                    id: 4,
                    name: 'Shelter 04'
                },
                {
                    id: 5,
                    name: 'Shelter 05'
                },
                {
                    id: 6,
                    name: 'Shelter 06'
                },

            ])

            return {
                ownerInfo,
                animalInfo,
                options,
                shelter,
                shelters,
            }

        }

    }

</script>

<style scoped>

    .section::after {

        content: "";

        background-image: url('/images/icons/arrow-black-small.svg');

        @apply w-10 h-2/8 absolute left-0 top-50 bg-center bg-repeat-y opacity-25

    }

@media screen and (max-width: 1024px) {

    .section::after {

        content: "";

        background-image: url('/images/icons/arrow-black-small.svg');

        display: none;

        @apply w-10 h-full absolute left-0 top-50 bg-center bg-repeat-y opacity-25

    }

}

</style>